module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/osbornebulls.64ed937.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/osbornebulls.jpg
// module id = GLEX
// module chunks = 0